import { useMutation, useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { getPrivateAxiosInstance } from '../../../axiosInstances/axiosPrivate';
import { AcademiaResponse } from '../../../types/common';
import { ManualTransactionHistory } from '../../../types/history';
import { returnQueryConfig } from '../../../utils/commonFunctions';

const useManualTransactionActions = (
  whichAction: 'manualTransactionList' | ''
) => {
  // query function to fetch all the manual transactions declared here
  const getManualTransactionListHandler = useQuery({
    queryKey: ['manual-transaction-list'],
    queryFn: async (): Promise<
      AcademiaResponse<Array<ManualTransactionHistory>>
    > => {
      const response = await getPrivateAxiosInstance('finance').get(
        '/manual/payment/list/'
      );

      return response.data;
    },

    ...returnQueryConfig(whichAction === 'manualTransactionList'),
  });

  // mutation function to create new manual transaction declared here
  const createManualTransactionHandler = useMutation({
    mutationFn: async ({
      body,
    }: {
      body: FormData;
    }): Promise<AcademiaResponse<ManualTransactionHistory>> => {
      const response = await getPrivateAxiosInstance('finance').post(
        '/manual/payment/create/',
        body
      );

      return response.data;
    },
  });

  // mutation function to update manual transaction declared heres
  const updateManualTransactionHandler = useMutation({
    mutationFn: async ({
      tranId,
      body,
    }: {
      tranId: number;
      body: FormData;
    }): Promise<AcademiaResponse<ManualTransactionHistory>> => {
      const response = await getPrivateAxiosInstance('finance').patch(
        `/manual/payment/${tranId}/partial/update/`,
        body
      );

      return response.data;
    },
  });

  // mutation function to delete manual transaction declared here
  const deleteManualTransactionHandler = useMutation({
    mutationFn: ({
      tranId,
    }: {
      tranId: number;
    }): Promise<AxiosResponse<AcademiaResponse<null>>> =>
      getPrivateAxiosInstance('finance').delete(
        `/manual/payment/${tranId}/delete/`
      ),
  });

  return {
    getManualTransactionListHandler,
    createManualTransactionHandler,
    updateManualTransactionHandler,
    deleteManualTransactionHandler,
  };
};

export default useManualTransactionActions;
